import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import PartnerForm from "components/form/PartnerForm";

import { SaveContextProvider } from "context/save";

import usePartnerForm from "hooks/form/usePartnerForm";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Partners creato con successo",
        errorMsg: "Errore nella creazione del partners",
        navigateTo: { link: "/partners" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovoPartnerInner() {
    const formPartnerHook = usePartnerForm();

    return (
        <>
            <PartnerForm formPartnerHook={formPartnerHook} />
            <ButtonSave />
        </>
    );
}

function NuovoPartner() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Nuovo Partners</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <NuovoPartnerInner />
            </SaveContextProvider>
        </Fragment>
    );
}

export default NuovoPartner;
